<template>
  <vxe-table border resizable show-overflow :data="tableData">
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) of tableColumn"
      :key="index"
      :field="item.field"
      :title="item.title"
      :edit-render="item.itemRender"
      :width="item.width"
    >
    </vxe-table-column>
  </vxe-table>
</template>

<script>
  export default {
    name: 'ExpandTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        tableColumn: [
          {
            title: '开票金额',
            field: 'invoicedAmount',
          },
          {
            title: '发票编码',
            field: 'invoiceCode',
          },
          {
            title: '开票数量',
            field: 'invoicedQuantity',
          },
          {
            title: '开票日期',
            field: 'invoicingDate',
          },
        ],
      };
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
